import { create } from 'zustand'
import { PortalBranding } from '@/types/branding.types'
import { SYSTEM_BRANDING } from '@/utils/branding'

interface BrandingState {
  branding: PortalBranding
  setBranding: (branding: PortalBranding) => void
}

export const useBrandingStore = create<BrandingState>(set => ({
  branding: SYSTEM_BRANDING,
  setBranding: branding => set({ branding }),
}))
